import FieldModel      from '@models/map/FieldModel';
import PlaceModel      from '@models/map/PlaceModel';
import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';
import Blamable        from '@/models/traits/Blamable';
import Translatable    from '@widesk-core/models/traits/Translatable';

@model.urnResource('place_field')
@doc.path('/place_fields/{?id}')
export default class PlaceFieldModel extends Blamable(TimestampAble(Translatable(MapServiceModel, {
	value: true,
}))) {
	private declare _tsFilters: {
		'createdAt': string;
		'field': id;
		'field.fieldType': id;
		'field.fieldType.reference': Map_FieldTypeReference;
		'place': id;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'field.label': string;
		'id': string;
		'updatedAt': string;
	};	

	@doc.model(FieldModel) declare field: FieldModel;
	@doc.model(PlaceModel) declare place: PlaceModel;
	@doc.string declare value: string;

}